import React, { useContext, useEffect, useState } from 'react';
import { Button, Flex, Icon } from '@chakra-ui/react';
import PersonaProvider from '../lib/personaProvider';
import PersonaAside from './components/personaAside';
import ExperiencesInPersonaList from '@/persona/[id]/components/experiencesInPersonaList';
import PersonaMembers from './components/personaMembers';
import PersonaBio from './components/personaBio';
import PersonaPageProvider from './lib/personaPageProvider';
import { useParams } from 'react-router-dom';
import usePersonaApi from '../lib/usePersonaApi';
import { AuthContext } from '../../auth/lib/authContext';
export default function PersonaDetailPage() {
  const [loadingPersona, setLoadingPersona] = useState(true);
  const [personaId, setPersonaId] = useState(null);
  const [readyToGetId, setReadyToGetId] = useState(null);

  const personaApi = usePersonaApi();
  const [marked, setMarked] = useState(false);
  const params = useParams();
  const { profile } = useContext(AuthContext);
   useEffect(() => {
    if(personaId && profile.id && !marked) {
      setMarked(true);
      personaApi.markAsOpened(personaId, profile.id)
    }
    }, [personaId, marked, profile.id])
  useEffect(() => {
    if (readyToGetId && params.id !== personaId) {
      setPersonaId(parseInt(params.id))
      setReadyToGetId(false);
    }
  }, [readyToGetId]);
  useEffect(() => {
    if (params.id && params.id !== personaId) {
      setReadyToGetId(true);
    }
  }, [params.id]);
  return (
    <>
      {personaId && (
        <>
        <PersonaProvider
          personaId={personaId}
          onInit={() => {
            setLoadingPersona(false);
          }}
          >
          <PersonaPageProvider>
            {!loadingPersona && (
            <Flex
            flexDirection="row"
            w="100%"
            h="100%"
          >
            <PersonaAside />
            <Flex
              flex="1"
              flexDirection={"column"}
              overflow={"auto"}
            >
              <Flex
                px={3}
                py={2}
                bg="white"
                borderBottom="1px solid"
                borderColor="divider.grey"
                justifyContent="flex-end"
              >
                <PersonaMembers />
              </Flex>
              <Flex
                flex="1"
                overflow={"auto"}
                flexDirection={'column'}
              >
                <Flex
                  flexDirection={'column'}
                  width={"100%"}
                  >
                  <PersonaBio />
                </Flex>
                <ExperiencesInPersonaList />
              </Flex>
            </Flex>
          </Flex>
            )}
          </PersonaPageProvider>
        </PersonaProvider>
      </>)}
    </>
  )
}
